import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { name: '首页', path: '/' },
    { name: '进口黄油推荐', path: '/category/imported-butter' },
    { name: '发酵黄油推荐', path: '/category/fermented-butter' },
    { name: '烘焙黄油推荐', path: '/category/baking-butter' },
    { name: '黄油品牌对比', path: '/category/brand-comparison' },
  ],
  黄油知识: [
    { name: '黄油选购指南', path: '/category/buying-guide' },
    { name: '家用黄油推荐', path: '/category/home-butter' },
    { name: '法国黄油完全指南', path: '/article/french-butter-complete-guide' },
    { name: '发酵黄油深度解析', path: '/article/fermented-butter-taste-test' },
    { name: '黄油保存技巧', path: '/article/butter-storage-tips' },
  ],
  关于我们: [
    { name: '品牌介绍', path: '/about' },
    { name: '联系方式', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 group">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-cake-2-line text-primary-500 text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-900">
                黄油推荐
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              精选高品质黄油完整指南。为烘焙爱好者、厨师及家庭用户提供专业、客观的黄油评测与选购建议。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                {title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 黄油推荐. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors"
              rel="nofollow"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors"
              rel="nofollow"
            >
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}